import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { PacingStatus } from "@features/mmm/components/shared/pacing-status";

import { type TableRowType } from "../performance-tracking-table";

export const PacingStatusDataFormatter = ({
  row: _row,
}: DataTypeProvider.ValueFormatterProps) => {
  const row = _row as TableRowType;

  return (
    <div className="font-sans flex-center h-full overflow-hidden">
      <PacingStatus
        className="text-xs font-semibold rounded-full"
        actual={row.data.actualSpend}
        budgeted={row.data.budgetedSpendToDate}
      />
    </div>
  );
};
